import api from "@/services/api";

import { SET_DIRECTIONS } from "@/store/mutation-types";

export default {
  async fetch({ commit }, { type, params }) {
    const { payload = {} } = await api.directions.fetch(type, params);
    const { directions = [], direction = {} } = payload;

    commit(SET_DIRECTIONS, type === "direction" ? [direction] : directions);

    return payload;
  }
};
